// Темплейты по умолчанию из документации

export const ARTISAN_EVOLVE_DEFAULT_TEMPLATES = [
  {
    id: 'default-artisan-1',
    name: 'General Contractor - Florida Single Location',
    createdAt: new Date().toISOString(),
    data: {
      account: {
        location: {
          id1: {
            county: 'DUVAL',
            state: 'FL',
            extraData: {
              idOriginal: 1
            }
          }
        }
      },
      version: {
        type: '13',
        number: '1.0.0'
      },
      policy: {
        state: 'FL',
        rateType: 'NB',
        effectiveDate: new Date().toISOString().split('T')[0],
        expirationDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        company: 'Beazley Insurance',
        companyShort: 'Beazley',
        lineGL: {
          risk: {
            '1_1': {
              code: 91340,
              exposure: 100000,
              extraData: {
                locationId: 1
              }
            }
          },
          policyPerOccurrenceLimit: 1000000,
          policyAggregateLimit: 2000000,
          productCompletedOperationLimit: 2000000,
          personalAdvertisingInjuryLimit: 1000000,
          deductibles: {
            pd: 0
          }
        },
        lossHistory: {
          items: {},
          priorClaim3years: 'no'
        },
        previousInsuranceItems: {}
      }
    }
  },
  {
    id: 'default-artisan-2',
    name: 'Carpentry - Georgia with Additional Insured',
    createdAt: new Date().toISOString(),
    data: {
      account: {
        location: {
          id1: {
            county: 'FULTON',
            state: 'GA',
            extraData: {
              idOriginal: 1
            }
          }
        }
      },
      version: {
        type: '13',
        number: '1.0.0'
      },
      policy: {
        state: 'GA',
        rateType: 'NB',
        effectiveDate: new Date().toISOString().split('T')[0],
        expirationDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        company: 'Beazley Insurance',
        companyShort: 'Beazley',
        lineGL: {
          risk: {
            '1_1': {
              code: 91343,
              exposure: 150000,
              extraData: {
                locationId: 1
              }
            }
          },
          policyPerOccurrenceLimit: 1000000,
          policyAggregateLimit: 2000000,
          productCompletedOperationLimit: 2000000,
          personalAdvertisingInjuryLimit: 1000000,
          deductibles: {
            pd: 500
          },
          optionalCoverages: {
            additionalInsured: {
              ai1: {
                form: 'CG2010',
                waiver: false
              }
            }
          }
        },
        lossHistory: {
          items: {},
          priorClaim3years: 'no'
        },
        previousInsuranceItems: {}
      }
    }
  },
  {
    id: 'default-artisan-3',
    name: 'Multi-Location Plumbing - South Carolina',
    createdAt: new Date().toISOString(),
    data: {
      account: {
        location: {
          id1: {
            county: 'CHARLESTON',
            state: 'SC',
            extraData: {
              idOriginal: 1
            }
          },
          id2: {
            county: 'GREENVILLE',
            state: 'SC',
            extraData: {
              idOriginal: 2
            }
          }
        }
      },
      version: {
        type: '13',
        number: '1.0.0'
      },
      policy: {
        state: 'SC',
        rateType: 'NB',
        effectiveDate: new Date().toISOString().split('T')[0],
        expirationDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        company: 'Beazley Insurance',
        companyShort: 'Beazley',
        lineGL: {
          risk: {
            '1_1': {
              code: 91583,
              exposure: 200000,
              extraData: {
                locationId: 1
              }
            },
            '2_1': {
              code: 91583,
              exposure: 75000,
              extraData: {
                locationId: 2
              }
            }
          },
          policyPerOccurrenceLimit: 1000000,
          policyAggregateLimit: 2000000,
          productCompletedOperationLimit: 2000000,
          personalAdvertisingInjuryLimit: 1000000,
          deductibles: {
            pd: 1000
          }
        },
        lossHistory: {
          items: {},
          priorClaim3years: 'no'
        },
        previousInsuranceItems: {}
      }
    }
  },
  {
    id: 'default-artisan-4',
    name: 'Electrical - Louisiana with TRIA Coverage',
    createdAt: new Date().toISOString(),
    data: {
      account: {
        location: {
          id1: {
            county: 'ORLEANS',
            state: 'LA',
            extraData: {
              idOriginal: 1
            }
          }
        }
      },
      version: {
        type: '13',
        number: '1.0.0'
      },
      policy: {
        state: 'LA',
        rateType: 'NB',
        effectiveDate: new Date().toISOString().split('T')[0],
        expirationDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        company: 'Beazley Insurance',
        companyShort: 'Beazley',
        lineGL: {
          risk: {
            '1_1': {
              code: 91581,
              exposure: 300000,
              extraData: {
                locationId: 1
              }
            }
          },
          policyPerOccurrenceLimit: 1000000,
          policyAggregateLimit: 2000000,
          productCompletedOperationLimit: 2000000,
          personalAdvertisingInjuryLimit: 1000000,
          deductibles: {
            pd: 250
          },
          optionalCoverages: {
            additionalInsured: {
              ai1: {
                form: 'CG2010',
                waiver: true
              }
            }
          }
        },
        optionalCoverages: {
          miscellaneous: {
            terrorism: {
              name: 'TRIA',
              title: 'Terrorism Risk Insurance Act Coverage'
            }
          }
        },
        lossHistory: {
          items: {},
          priorClaim3years: 'no'
        },
        previousInsuranceItems: {},
        specialCrDr: {
          largeRiskDiscountFactor: '-select-',
          management: '2.5',
          safetyPrograms: '1.5',
          supervisionEmployeeExperience: '3',
          specialCharacteristics: '2'
        }
      }
    }
  }
];

export const WDBB_SATINWOOD_DEFAULT_TEMPLATES = [
  {
    id: 'default-1',
    name: 'Example 1: Simple Single Building (Atlanta, GA)',
    createdAt: new Date().toISOString(),
    data: {
      policy: {
        state: 'GA',
        effectiveDate: new Date().toISOString().split('T')[0],
        expirationDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        lineWDBB: {
          applicationMethod: 'perBuilding',
          deductibleType: 'percent',
          overlyingDeductiblePercent: '2',
          overlyingDeductibleMinimum: '',
          overlyingDeductibleFlat: '',
          retentionType: 'flat',
          retentionPercent: '',
          retentionMinimum: '',
          retentionFlat: '10000'
        },
        lossHistory: []
      },
      account: {
        locations: [
          {
            id: '1',
            county: 'Fulton',
            distanceToCoast: '200',
            buildings: [
              {
                id: '1',
                totalInsuredValue: '1000000',
                construction: 'Fire Resistive',
                roofType: 'Metal',
                roofAge: '7',
                yearBuilt: '2018',
                occupancy: 'Office'
              }
            ]
          }
        ]
      }
    }
  },
  {
    id: 'default-2',
    name: 'Example 2: Multi-County Complex (Texas)',
    createdAt: new Date().toISOString(),
    data: {
      policy: {
        state: 'TX',
        effectiveDate: new Date().toISOString().split('T')[0],
        expirationDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        lineWDBB: {
          applicationMethod: 'perOccurrence',
          deductibleType: 'percent',
          overlyingDeductiblePercent: '4',
          overlyingDeductibleMinimum: '',
          overlyingDeductibleFlat: '',
          retentionType: 'flat',
          retentionPercent: '',
          retentionMinimum: '',
          retentionFlat: '200000'
        },
        lossHistory: [{ date: new Date().toISOString().split('T')[0], amount: 50000 }]
      },
      account: {
        locations: [
          {
            id: '1',
            county: 'Harris',
            distanceToCoast: '10',
            buildings: [
              {
                id: '1',
                totalInsuredValue: '5000000',
                construction: 'Frame',
                roofType: 'Shingle',
                roofAge: '15',
                yearBuilt: '2005',
                occupancy: 'Hotel/Motel'
              }
            ]
          },
          {
            id: '2',
            county: 'Dallas',
            distanceToCoast: '300',
            buildings: [
              {
                id: '1',
                totalInsuredValue: '3000000',
                construction: 'Frame',
                roofType: 'Shingle',
                roofAge: '15',
                yearBuilt: '2005',
                occupancy: 'Hotel/Motel'
              }
            ]
          },
          {
            id: '3',
            county: 'Travis',
            distanceToCoast: '150',
            buildings: [
              {
                id: '1',
                totalInsuredValue: '2000000',
                construction: 'Frame',
                roofType: 'Shingle',
                roofAge: '15',
                yearBuilt: '2005',
                occupancy: 'Hotel/Motel'
              }
            ]
          }
        ]
      }
    }
  },
  {
    id: 'default-3',
    name: 'Example 3: Maximum Credit (Westchester, NY)',
    createdAt: new Date().toISOString(),
    data: {
      policy: {
        state: 'NY',
        effectiveDate: new Date().toISOString().split('T')[0],
        expirationDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        lineWDBB: {
          applicationMethod: 'perBuilding',
          deductibleType: 'percent',
          overlyingDeductiblePercent: '2',
          overlyingDeductibleMinimum: '',
          overlyingDeductibleFlat: '',
          retentionType: 'flat',
          retentionPercent: '',
          retentionMinimum: '',
          retentionFlat: '500000'
        },
        lossHistory: []
      },
      account: {
        locations: [
          {
            id: '1',
            county: 'Westchester',
            distanceToCoast: '15',
            buildings: [
              {
                id: '1',
                totalInsuredValue: '50000000',
                construction: 'Fire Resistive',
                roofType: 'Metal',
                roofAge: '5',
                yearBuilt: '2020',
                occupancy: 'Office'
              }
            ]
          }
        ]
      }
    }
  },
  {
    id: 'default-4',
    name: 'Example 4: Multi-Building Per Location (Broward, FL)',
    createdAt: new Date().toISOString(),
    data: {
      policy: {
        state: 'FL',
        effectiveDate: new Date().toISOString().split('T')[0],
        expirationDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        lineWDBB: {
          applicationMethod: 'perLocation',
          deductibleType: 'percent',
          overlyingDeductiblePercent: '3',
          overlyingDeductibleMinimum: '',
          overlyingDeductibleFlat: '',
          retentionType: 'flat',
          retentionPercent: '',
          retentionMinimum: '',
          retentionFlat: '50000'
        },
        lossHistory: []
      },
      account: {
        locations: [
          {
            id: '1',
            county: 'Broward',
            distanceToCoast: '3',
            buildings: [
              {
                id: '1',
                totalInsuredValue: '2000000',
                construction: 'JM',
                roofType: 'Tile',
                roofAge: '40',
                yearBuilt: '1985',
                occupancy: 'Office'
              },
              {
                id: '2',
                totalInsuredValue: '3000000',
                construction: 'JM',
                roofType: 'Metal',
                roofAge: '10',
                yearBuilt: '2010',
                occupancy: 'Office'
              },
              {
                id: '3',
                totalInsuredValue: '5000000',
                construction: 'JM',
                roofType: 'Metal',
                roofAge: '6',
                yearBuilt: '2019',
                occupancy: 'Office'
              }
            ]
          }
        ]
      }
    }
  }
];
// --- Фабрики для компактного описания шаблонов Mercantile Brace ---
const mbCreatedAt = new Date().toISOString();
const mbToday = new Date().toISOString().split('T')[0];
const mbNextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0];

const mbCov = (over = {}) => ({
  type: 'Building',
  limit: 500000,
  deductible: 2500,
  causeOfLoss: 'Basic',
  shuttersCredit: false,
  dbcrNonWind: '',
  dbcrWind: '',
  ...over
});

const mbBuilding = (over = {}) => ({
  name: '',
  construction: 'JM',
  occupancy: 'Mercantile',
  protectionClass: '3',
  yearBuilt: 2005,
  distanceToCoast: '>10 but <30 miles',
  windSelect: true,
  nse: false,
  windDeductible: '5%',
  windDeductibleOption: 'Hurricane',
  shutters: '',
  vacancy: '',
  fireAlarmMonitored: false,
  fireAutomaticFire: false,
  fireSprinkler: false,
  renoPlumbingYear: '',
  renoWiringYear: '',
  renoHeatingYear: '',
  renoRoofingYear: '',
  expShopCarpentry: false,
  expAutoRepair: false,
  expAutoPaint: false,
  expWelding: false,
  expManufacturing: false,
  expCommercialCooking: false,
  cookFryer: false,
  cookGrill: false,
  cookOpenFlame: false,
  cookOther: false,
  cookingPBI: '50% or more',
  coverages: [mbCov()],
  ...over
});

const mbTemplate = (id, name, opts = {}) => {
  const {
    state = 'FL', rateType = 'NB', tria = false, lp = {},
    county = 'Duval', locName = '', isMetropolitan = false, buildings
  } = opts;
  return {
    id,
    name,
    createdAt: mbCreatedAt,
    data: {
      policy: {
        state,
        rateType,
        effectiveDate: mbToday,
        expirationDate: mbNextYear,
        lineProperty: {
          highCrimeArea: false,
          isLossHist: false,
          lossHistoryDateLast: '',
          lossHistoryDateLastAll: '',
          finalPremiumCredit: '',
          ...lp
        },
        triaProperty: tria
      },
      locations: [
        {
          name: locName,
          county,
          isMetropolitan,
          inspection: false,
          buildings: buildings || [mbBuilding()]
        }
      ]
    }
  };
};

export const MERCANTILE_BRACE_DEFAULT_TEMPLATES = [
  // 1. Базовый: инлендовый Mercantile, здание + содержимое
  mbTemplate('mb-1', 'FL Duval — Mercantile (Building + Contents)', {
    county: 'Duval',
    locName: 'Main Street Plaza',
    buildings: [
      mbBuilding({
        coverages: [
          mbCov({ type: 'Building', limit: 500000 }),
          mbCov({ type: 'Contents', limit: 100000 })
        ]
      })
    ]
  }),

  // 2. Tri-County Miami-Dade, прибрежный, TRIA (metropolitan)
  mbTemplate('mb-2', 'FL Miami-Dade — Tri-County coastal + TRIA', {
    county: 'Miami-Dade',
    locName: 'Biscayne Retail',
    isMetropolitan: true,
    tria: true,
    buildings: [
      mbBuilding({
        construction: 'M-NC',
        occupancy: 'Mercantile',
        protectionClass: '2',
        yearBuilt: 2012,
        distanceToCoast: '0.5 - 1 Mile',
        windDeductible: '5%',
        coverages: [mbCov({ limit: 1500000 }), mbCov({ type: 'Contents', limit: 400000 })]
      })
    ]
  }),

  // 3. Monroe (Keys), максимально прибрежный, ставни, высокий wind
  mbTemplate('mb-3', 'FL Monroe (Keys) — coastal Motels, shutters', {
    county: 'Monroe',
    locName: 'Overseas Hwy Motel',
    buildings: [
      mbBuilding({
        construction: 'M-NC',
        occupancy: 'Motels',
        protectionClass: '4',
        yearBuilt: 2016,
        distanceToCoast: '0 - 0.5 Mile',
        windDeductible: '10%',
        shutters: '1 - All openings designed for large missiles',
        coverages: [mbCov({ limit: 2000000 }), mbCov({ type: 'Business Income With Extra Expense', limit: 300000 })]
      })
    ]
  }),

  // 4. Broward, офис, sprinklered + alarm, Special cause of loss
  mbTemplate('mb-4', 'FL Broward — Office, sprinklered + alarm, Special', {
    county: 'Broward',
    locName: 'Sunrise Office Park',
    buildings: [
      mbBuilding({
        construction: 'F-R',
        occupancy: 'Other',
        protectionClass: '1',
        yearBuilt: 2018,
        distanceToCoast: '2 - 5 Miles',
        fireAlarmMonitored: true,
        fireSprinkler: true,
        coverages: [mbCov({ limit: 3000000, causeOfLoss: 'Special' }), mbCov({ type: 'Contents', limit: 500000, causeOfLoss: 'Special' })]
      })
    ]
  }),

  // 5. Hillsborough (Tampa), старое здание (до 1996 — wind surcharge зона 1), ставни
  mbTemplate('mb-5', 'FL Hillsborough — older Apartments (1985), shutters', {
    county: 'Hillsborough',
    locName: 'Bayshore Apartments',
    buildings: [
      mbBuilding({
        construction: 'JM',
        occupancy: 'Apartments',
        protectionClass: '4',
        yearBuilt: 1985,
        distanceToCoast: '1 - 2 Miles',
        windDeductible: '5%',
        shutters: '2 - All openings designed for medium missiles',
        coverages: [mbCov({ limit: 2500000 })]
      })
    ]
  }),

  // 6. Orange (Orlando) metropolitan, отель, TRIA, sprinklered
  mbTemplate('mb-6', 'FL Orange (Orlando) — Hotel, metro TRIA', {
    county: 'Orange',
    locName: 'International Dr Hotel',
    isMetropolitan: true,
    tria: true,
    buildings: [
      mbBuilding({
        construction: 'F-R',
        occupancy: 'Hotels',
        protectionClass: '2',
        yearBuilt: 2015,
        distanceToCoast: '>30 miles',
        fireSprinkler: true,
        fireAlarmMonitored: true,
        coverages: [mbCov({ limit: 8000000 }), mbCov({ type: 'Business Income With Extra Expense', limit: 1000000 })]
      })
    ]
  }),

  // 7. Alachua (Gainesville), инленд, без ветра, Special
  mbTemplate('mb-7', 'FL Alachua — inland Mercantile LRO, no wind', {
    county: 'Alachua',
    locName: 'Archer Rd Plaza',
    buildings: [
      mbBuilding({
        construction: 'M-NC',
        occupancy: 'Mercantile LRO (non-manufacturing)',
        protectionClass: '3',
        yearBuilt: 2008,
        distanceToCoast: '>30 miles',
        windSelect: false,
        coverages: [mbCov({ limit: 750000, causeOfLoss: 'Special' })]
      })
    ]
  }),

  // 8. Pinellas прибрежный, Named Windstorm option
  mbTemplate('mb-8', 'FL Pinellas — coastal, Named Windstorm', {
    county: 'Pinellas',
    locName: 'Gulf Blvd Retail',
    buildings: [
      mbBuilding({
        construction: 'M-NC',
        occupancy: 'Mercantile',
        protectionClass: '3',
        yearBuilt: 2010,
        distanceToCoast: '0.5 - 1 Mile',
        windDeductible: '5%',
        windDeductibleOption: 'Named Windstorm',
        nse: true,
        coverages: [mbCov({ limit: 1200000 })]
      })
    ]
  }),

  // 9. LA Orleans (New Orleans), прибрежный, высокий ветер
  mbTemplate('mb-9', 'LA Orleans — coastal Mercantile', {
    state: 'LA',
    county: 'Orleans',
    locName: 'Canal St Retail',
    buildings: [
      mbBuilding({
        construction: 'F-R',
        occupancy: 'Mercantile',
        protectionClass: '2',
        yearBuilt: 2014,
        distanceToCoast: '2 - 5 Miles',
        windDeductible: '5%',
        coverages: [mbCov({ limit: 1800000 }), mbCov({ type: 'Contents', limit: 300000 })]
      })
    ]
  }),

  // 10. LA East Baton Rouge, инленд офис, без ветра
  mbTemplate('mb-10', 'LA East Baton Rouge — inland Office', {
    state: 'LA',
    county: 'East Baton Rouge',
    locName: 'Government St Office',
    buildings: [
      mbBuilding({
        construction: 'JM',
        occupancy: 'Other',
        protectionClass: '3',
        yearBuilt: 2006,
        distanceToCoast: '>30 miles',
        windSelect: false,
        coverages: [mbCov({ limit: 900000 })]
      })
    ]
  }),

  // 11. LA Jefferson прибрежный, апартаменты
  mbTemplate('mb-11', 'LA Jefferson — coastal Apartments', {
    state: 'LA',
    county: 'Jefferson',
    locName: 'Metairie Apartments',
    buildings: [
      mbBuilding({
        construction: 'JM',
        occupancy: 'Apartments',
        protectionClass: '4',
        yearBuilt: 2009,
        distanceToCoast: '2 - 5 Miles',
        windDeductible: '5%',
        coverages: [mbCov({ limit: 2200000 })]
      })
    ]
  }),

  // 12. Palm Beach (Tri-County) кондо, полностью обновлённое + защиты
  mbTemplate('mb-12', 'FL Palm Beach — Tri-County Condos, fully updated', {
    county: 'Palm Beach',
    locName: 'Ocean View Condos',
    buildings: [
      mbBuilding({
        construction: 'M-NC',
        occupancy: 'Condos',
        protectionClass: '2',
        yearBuilt: 2003,
        distanceToCoast: '1 - 2 Miles',
        windDeductible: '5%',
        fireAlarmMonitored: true,
        fireSprinkler: true,
        renoPlumbingYear: '2022',
        renoWiringYear: '2022',
        renoHeatingYear: '2021',
        renoRoofingYear: '2023',
        shutters: '1 - All openings designed for large missiles',
        coverages: [mbCov({ limit: 5000000 })]
      })
    ]
  }),

  // 13. Vacant + high crime + loss history
  mbTemplate('mb-13', 'FL Duval — Vacant, High Crime, Loss History', {
    county: 'Duval',
    locName: 'Downtown Vacant Bldg',
    lp: {
      highCrimeArea: true,
      isLossHist: true,
      lossHistoryDateLast: '2024-05-10',
      lossHistoryDateLastAll: '2024-05-10'
    },
    buildings: [
      mbBuilding({
        construction: 'M-NC',
        occupancy: 'Other',
        protectionClass: '5',
        yearBuilt: 1998,
        distanceToCoast: '>10 but <30 miles',
        vacancy: 'Completely Vacant',
        coverages: [mbCov({ limit: 800000, deductible: 5000 })]
      })
    ]
  }),

  // 14. Lee (Fort Myers) прибрежный, опасные exposures (welding + auto repair)
  mbTemplate('mb-14', 'FL Lee — coastal, Hazardous Exposures', {
    county: 'Lee',
    locName: 'Industrial Ave Shop',
    buildings: [
      mbBuilding({
        construction: 'M-NC',
        occupancy: 'Mercantile',
        protectionClass: '4',
        yearBuilt: 2011,
        distanceToCoast: '2 - 5 Miles',
        windDeductible: '5%',
        expWelding: true,
        expAutoRepair: true,
        coverages: [mbCov({ limit: 1300000 }), mbCov({ type: 'Contents', limit: 250000 })]
      })
    ]
  }),

  // 15. Collier (Naples) прибрежный, коммерческая кухня + TRIA
  mbTemplate('mb-15', 'FL Collier (Naples) — Commercial Cooking + TRIA', {
    county: 'Collier',
    locName: 'Naples Bayfront',
    tria: true,
    buildings: [
      mbBuilding({
        construction: 'F-R',
        occupancy: 'Hotels',
        protectionClass: '2',
        yearBuilt: 2017,
        distanceToCoast: '0.5 - 1 Mile',
        windDeductible: '5%',
        fireSprinkler: true,
        expCommercialCooking: true,
        cookFryer: true,
        cookGrill: true,
        cookingPBI: '25% to 49%',
        coverages: [mbCov({ limit: 6000000 }), mbCov({ type: 'Business Income With Extra Expense', limit: 800000 })]
      })
    ]
  })
];
